export default "__VITE_ASSET__a7f45f3b__"